import React from "react";
import styles from "./styles";

const ImageCard = (props: any) => {
  const { url } = props;
  const classes = styles();
  return (
    <img
      className={classes.mainImage}
      src={url}
      // onError={() => alert("error")}
      alt="Cargando Imagen..."
    />
  );
};

export default ImageCard;
